import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";

export interface RuntimeConfig {
    vapidPublicKey: string;
}

@Injectable({
    providedIn: "root",
})
export class RuntimeConfigService {
    private config: RuntimeConfig | null = null;

    constructor(private http: HttpClient) {}

    public async loadConfig(): Promise<RuntimeConfig> {
        if (this.config) {
            return this.config;
        }

        try {
            this.config = await firstValueFrom(this.http.get<RuntimeConfig>("/api/configuration/runtime"));
            return this.config;
        } catch (error) {
            console.error("Failed to load runtime configuration, using fallback", error);
            this.config = {
                vapidPublicKey:
                    "BG0U6UlYizO77czuXesDEpaw7ixCPPiWJxFFu48HOQClqhFh4Xv9ey3UL1UiAO5mjZTVwA28isgn0-usEtHcJOY",
            };
            return this.config;
        }
    }

    public getConfig(): RuntimeConfig {
        if (!this.config) {
            throw new Error("Configuration not loaded. Call loadConfig() first.");
        }
        return this.config;
    }

    public getConfigOrDefault(): RuntimeConfig {
        return this.config ?? {
            vapidPublicKey: "BG0U6UlYizO77czuXesDEpaw7ixCPPiWJxFFu48HOQClqhFh4Xv9ey3UL1UiAO5mjZTVwA28isgn0-usEtHcJOY",
        };
    }
}
